module.exports = __webpack_public_path__ + "static/media/12_r_derejabl_81.04_11.02.d3d393bb.png";